import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const buttonDefaultVariants = {
  "variant": "primary",
  "kind": "solid",
  "size": "md"
}
const buttonCompoundVariants = [
  {
    "isFull": true,
    "isDropdown": true,
    "css": {
      "iconEnd": {
        "flex": "1 1 auto"
      },
      "iconStart": {
        "flex": "1 1 auto"
      }
    }
  },
  {
    "isRounded": true,
    "kind": "link",
    "css": {
      "root": {
        "borderRadius": "0"
      }
    }
  }
]

const buttonSlotNames = [
  [
    "root",
    "Button__root"
  ],
  [
    "label",
    "Button__label"
  ],
  [
    "iconStart",
    "Button__iconStart"
  ],
  [
    "iconEnd",
    "Button__iconEnd"
  ],
  [
    "dropdownIcon",
    "Button__dropdownIcon"
  ]
]
const buttonSlotFns = /* @__PURE__ */ buttonSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, buttonDefaultVariants, getSlotCompoundVariant(buttonCompoundVariants, slotName))])

const buttonFn = memo((props = {}) => {
  return Object.fromEntries(buttonSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const buttonVariantKeys = [
  "size",
  "variant",
  "kind",
  "isFull",
  "isDropdown",
  "isRounded"
]
const getVariantProps = (variants) => ({ ...buttonDefaultVariants, ...compact(variants) })

export const button = /* @__PURE__ */ Object.assign(buttonFn, {
  __recipe__: false,
  __name__: 'button',
  raw: (props) => props,
  variantKeys: buttonVariantKeys,
  variantMap: {
  "size": [
    "xs",
    "sm",
    "md",
    "lg"
  ],
  "variant": [
    "primary",
    "secondary",
    "ghost",
    "subtle",
    "accent",
    "warning",
    "danger",
    "success"
  ],
  "kind": [
    "solid",
    "minimal",
    "link"
  ],
  "isFull": [
    "true"
  ],
  "isDropdown": [
    "true"
  ],
  "isRounded": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, buttonVariantKeys)
  },
  getVariantProps
})